







import { Vue, Component, Prop } from 'vue-property-decorator'
import { FileInfo, VFS, PathController } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'

import Loader from '@/components/Loader.vue'

interface FileInfoWithThumbnail extends FileInfo {
  Thumbnails?: string[];
}

@Component({
  components: { Loader }
})
export default class GlobusPricechecker extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController

  private filesWithThumbnail: FileInfoWithThumbnail[] = []
  private isReady = false

  async mounted () {
    const { kiwi } = window
    if (kiwi) {
      kiwi.on('barcodeScanned', (ean: unknown) => {
        console.log(ean)
        this.pathController.push(`${ean}.jpg`)
      })
    }
    const bc = new BroadcastChannel('test')
    bc.onmessage = (ev: MessageEvent) => {
      console.log(ev?.data)
      this.pathController.push(`${ev?.data}.jpg`)
    }
    this.isReady = true
  }

  handleScroll (event: any) {
    this.$emit('on-scroll', event.target.scrollTop)
  }
}

